import { apiUrl } from '../config/api'

/**
 * Upload a file to Cloudflare R2.
 * @param {File} file - The file to upload
 * @param {string} [path] - Optional path. If set, uploads to this path (overwrites). If not, backend generates one.
 * @returns {Promise<{ path: string }>}
 */
export async function uploadImage(file, path) {
  const formData = new FormData()
  formData.append('file', file)
  if (path) formData.append('path', path)

  const secret = localStorage.getItem('x-auth-secret') || localStorage.getItem('authSecret') || ''
  const headers = {}
  if (secret) headers['x-auth-secret'] = secret

  const res = await fetch(apiUrl('/api/upload'), {
    method: 'POST',
    headers,
    credentials: 'include',
    body: formData,
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }))
    throw new Error(err.error || 'Upload failed')
  }
  return res.json()
}
